import React from "react";

const OrganizationAnalysts = () => {
    return <>OrganizationAnalysts...</>;
};

export default OrganizationAnalysts;
